import { FirebaseApp } from "firebase/app";
import { createContext } from "react";

export const AppContext = createContext<FirebaseApp|null>(null);
